const adminMenuItems = [
  {
    name: "นิเคอิ",
    icon: "flag-icon-jp",
    iconPack: "flag-icons",
    class: 'group-jp',
    url: '/result/jp'
  },
  {
    name: "จีน",
    icon: "flag-icon-cn",
    iconPack: "flag-icons",
    class: 'group-cn',
    url: '/result/cn'
  },
  {
    name: "ฮั่งเส็ง",
    icon: "flag-icon-hk",
    iconPack: "flag-icons",
    class: 'group-hk',
    url: '/result/hk'
  },
  {
    name: "ไต้หวัน",
    icon: "flag-icon-tw",
    iconPack: "flag-icons",
    class: 'group-tw',
    url: '/result/tw'
  },
  {
    name: "เกาหลี",
    icon: "flag-icon-kr",
    iconPack: "flag-icons",
    class: 'group-kr',
    url: '/result/kr'
  },
  {
    name: "สิงคโปร์",
    icon: "flag-icon-sg",
    iconPack: "flag-icons",
    class: 'group-sg',
    url: '/result/sg'
  },
  {
    name: "อินเดีย",
    icon: "flag-icon-in",
    iconPack: "flag-icons",
    class: 'group-in',
    url: '/result/in'
  }
]

const memberMenuItems = [{
  url: "/",
  name: "Home",
  slug: "home",
  icon: "HomeIcon"
}]

export { adminMenuItems, memberMenuItems }
